import { select } from '@ngneat/elf';
import { BaseStoreRepository } from '../../base-store.repository';
import {
  DynaDocsModelStatusProps,
  getDynaDocsModelStatusInitialState,
  DynaDocsModelStatusStore,
} from './dyna-docs-model-status.store';
import { ParamGeneralStatus } from '@/types';

export class DynaDocsModelStatusRepository extends BaseStoreRepository<DynaDocsModelStatusProps> {
  constructor(store: DynaDocsModelStatusStore) {
    super(store.pipe(select(state => state)), store, { ...getDynaDocsModelStatusInitialState() });
  }

  setFromResponse(response: any) {
    this.set('dto', {
      dynaDocsModelId: response.dynaDocsModel?.dynaDocsModelId,
      paramGeneralStatus: response.paramGeneralStatus,
    });
    this.set('dynaDocsModelSelected', {
      name: response.dynaDocsModel?.description,
      code: response.dynaDocsModel?.dynaDocsModelId,
    });
    this.set('statusSelected', {
      name: response.paramGeneralStatus === ParamGeneralStatus.ACTIF ? 'Actif' : 'Non Actif',
      code: response.paramGeneralStatus,
    });
  }
}

export const DynaDocsModelStatusRepositoryFactory = {
  create(store: DynaDocsModelStatusStore) {
    return new DynaDocsModelStatusRepository(store);
  },
};
